import { createRoot } from 'react-dom/client';
import ConfirmationDialog from './index';

const HOST_ID = 'confirmation-dialog-host';

const getOrCreateHost = () => {
    let host = document.getElementById(HOST_ID);
    if (!host) {
        host = document.createElement('div');
        host.id = HOST_ID;
        document.body.appendChild(host);
    }
    return host;
};

const unmountHost = (root, host) => {
    root.unmount();
    host.remove();
};

/**
 * Imperatively show a confirmation dialog via ModalComponent.
 *
 * @param {object} config
 * @returns {Promise<boolean>} resolves true on confirm, false on cancel/close
 */
export function showConfirmationDialog({
    id = 'confirmation-dialog',
    title,
    subtitle,
    message,
    confirmQuestion,
    cancelLabel,
    confirmLabel,
    confirmVariant = 'info',
    onConfirm,
    onCancel,
}) {
    const host = getOrCreateHost();
    const root = createRoot(host);

    const getIcon = () => {    
        if (confirmVariant === 'danger') {
            return 'icon-svg-alert-circle';
        }
        return 'icon-svg-info-circle';
    };

    return new Promise((resolve) => {
        root.render(
            <ConfirmationDialog
                id={id}
                show
                title={title}
                subtitle={subtitle}
                icon={getIcon()}
                message={message}
                confirmQuestion={confirmQuestion}
                cancelLabel={cancelLabel}
                confirmLabel={confirmLabel}
                confirmVariant={confirmVariant}
                onConfirm={onConfirm}
                onCancel={onCancel}
                onClosed={(confirmed) => {
                    unmountHost(root, host);
                    resolve(confirmed);
                }}
            />,
        );
    });
}

export default showConfirmationDialog;
